import { jsx } from '@emotion/core';
import Context from './Context';

var fallbackIfNeeded = function fallbackIfNeeded(languageString) {
  return /^\w{2}-[A-Z]{2}$/.test(languageString) ? languageString : 'en-US';
};

var LocalizationProvider = function LocalizationProvider(_a) {
  var children = _a.children,
      locale = _a.locale;
  return jsx(Context.Provider, {
    value: {
      language: fallbackIfNeeded(locale)
    }
  }, children);
};

export default LocalizationProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/localization/Provider.js
// module id = 793
// module chunks = 0